/*
 * This contains all the text for overhang options
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noOverhang: {
    id: 'cwt.translations.NoOverhang',
    defaultMessage: 'No overhang',
    description: {
      labelGroup: 'Overhang',
    },
  },
  noWaterfall: {
    id: 'cwt.translations.NoWaterfall',
    defaultMessage: 'No waterfall',
    description: {
      labelGroup: 'Overhang',
    },
  },
  waterfall45Degrees: {
    id: 'cwt.translations.Waterfall45Degrees',
    defaultMessage: 'Waterfall 45 Degrees',
    description: {
      labelGroup: 'Overhang',
    },
  },
  waterfallWithOverhang45Degrees: {
    id: 'cwt.translations.WaterfallWithOverhang45Degrees',
    defaultMessage: 'Waterfall with overhang 45 Degrees',
    description: {
      labelGroup: 'Overhang',
    },
  },
  waterfall90Degrees: {
    id: 'cwt.translations.Waterfall90Degrees',
    defaultMessage: 'Waterfall 90 Degrees',
    description: {
      labelGroup: 'Overhang',
    },
  },
  waterfallWithOverhang90Degrees: {
    id: 'cwt.translations.WaterfallWithOverhang90Degrees',
    defaultMessage: 'Waterfall with overhang 90 Degrees',
    description: {
      labelGroup: 'Overhang',
    },
  },
  arc: {
    id: 'cwt.translations.Arc',
    defaultMessage: 'Arc',
    description: {
      labelGroup: 'Overhang',
    },
  },
  twoRounded: {
    id: 'cwt.translations.TwoRounded',
    defaultMessage: 'Two rounded corners',
    description: {
      labelGroup: 'Overhang',
    },
  },
  oneRounded: {
    id: 'cwt.translations.OneRounded',
    defaultMessage: 'One rounded corner',
    description: {
      labelGroup: 'Overhang',
    },
  },
  emerald: {
    id: 'cwt.translations.Emerald',
    defaultMessage: 'Emerald',
    description: {
      labelGroup: 'Overhang',
    },
  },
  noCorners: {
    id: 'cwt.translations.NoCorners',
    defaultMessage: 'No corner cuts',
    description: {
      labelGroup: 'Overhang',
    },
  },
  halfEmerald: {
    id: 'cwt.translations.HalfEmerald',
    defaultMessage: 'Half emerald',
    description: {
      labelGroup: 'Overhang',
    },
  },
  oneSide: {
    id: 'cwt.translations.OneSide',
    defaultMessage: 'One side',
    description: {
      labelGroup: 'Overhang Side',
    },
  },
  twoSides: {
    id: 'cwt.translations.TwoSides',
    defaultMessage: 'Two sides',
    description: {
      labelGroup: 'Overhang Side',
    },
  },
  threeSides: {
    id: 'cwt.translations.ThreeSides',
    defaultMessage: 'Three sides',
    description: {
      labelGroup: 'Overhang Side',
    },
  },
  fourSides: {
    id: 'cwt.translations.FourSides',
    defaultMessage: 'Four sides',
    description: {
      labelGroup: 'Overhang Side',
    },
  },
});
